import React from "react";
import App from "./App";
// Add any frontend configs on this file (BrowserRouter, Redux Provider, etc)

const Main = () => <App />;

export default Main;
